//@flow

import * as React from "react"
import { FormattedMessage } from "react-intl"
import Warn from "./Warn.js"
import { FieldIndicator } from "../Indicators"
import styled from "styled-components"

import type { FieldProps } from "redux-form"

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

const CustomField = (
  InputFieldComponent: React.ComponentType<any>,
  ErrorComponent: React.ComponentType<any>
) => ({
  input,
  type,
  step,
  disabled,
  placeholder,
  meta: { touched, error, warning, asyncValidating, pristine }
}: FieldProps) => (
  <div>
    <Wrapper>
      <InputFieldComponent
        {...input}
        placeholder={placeholder}
        type={type}
        step={step}
        error={touched && error}
        disabled={disabled ? disabled : false}
      />
      {asyncValidating ? <FieldIndicator /> : ""}
    </Wrapper>
    {!pristine &&
      ((error && (
        <ErrorComponent>
          <FormattedMessage id={error} />
        </ErrorComponent>
      )) ||
        (warning && <Warn>{warning}</Warn>))}
  </div>
)

export default CustomField



// WEBPACK FOOTER //
// ./src/UI/Form/CustomField.js